import { render, staticRenderFns } from "./ConversionDashboard.vue?vue&type=template&id=bd7a17c4&scoped=true&"
import script from "./ConversionDashboard.vue?vue&type=script&lang=ts&"
export * from "./ConversionDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd7a17c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
